import styled from 'styled-components';
import { Grid } from '@simplywallst/ui-core';

export const StyledGridWrapper = styled(Grid)`
  height: 100%;
  width: 100%;
  padding: ${({ theme }) =>
    `0 ${theme.x3spacePx}px calc(${theme.x2spacePx}px + ${theme.safeAreaInsetBottom})`};
`;
